import "./style.scss";
import { Dispatch, FC, SetStateAction } from "react";
import { IRowData } from "@/src/types/applicationOnline";
import VerticalLine from "@/src/components/VerticalLine/VerticalLine";

interface IGeneralInformation {
  viewData: IRowData | undefined;
  draftData: IRowData | undefined;
  editor: boolean;
  setEditorDraft: Dispatch<SetStateAction<IRowData | undefined>>;
}

const GeneralInformation: FC<IGeneralInformation> = ({ viewData, draftData, editor, setEditorDraft }) => {
  const updateUserInfo = (key: keyof IRowData["userInfo"], value: string) => {
    setEditorDraft((prev) =>
      prev
        ? {
            ...prev,
            userInfo: {
              ...prev.userInfo,
              [key]: value,
            },
          }
        : prev,
    );
  };
  const updateApplyInfo = (key: keyof IRowData["applyInfo"], value: string) => {
    setEditorDraft((prev) =>
      prev
        ? {
            ...prev,
            applyInfo: {
              ...prev.applyInfo,
              [key]: value,
            },
          }
        : prev,
    );
  };

  return (
    <div className="general-information">
      <div className="general-information-title">
        <p>{viewData?.userInfo.fullname}</p>
      </div>
      <div className="general-information-main">
        <div className="general-information-main-block">
          <div className="general-information-main-block-item">
            <p>Data</p>
            <VerticalLine />
            <span>{viewData?.applyInfo.date?.split(" ")[0]}</span>
          </div>
          <div className="general-information-main-block-item">
            <p>Updated</p>
            <VerticalLine />
            <span>{viewData?.applyInfo.updated.split(" ")[0]}</span>
          </div>
          <div className="general-information-main-block-item">
            <p>Applications</p>
            <VerticalLine />
            <span>New application</span>
          </div>
        </div>
        <div className="general-information-main-block">
          <div className="general-information-main-block-item">
            <p>ID No</p>
            <VerticalLine />
            <span>{viewData?.applyInfo.id}</span>
          </div>
          <div className="general-information-main-block-item">
            <p>Status</p>
            <VerticalLine />
            <div className={`status-option ${viewData?.applyInfo.status}`}>
              <span>{viewData?.applyInfo.status}</span>
            </div>
          </div>
          <div className="general-information-main-block-item">
            <p>Payment Status</p>
            <VerticalLine />
            <div className={`status-option not_sorted`}>
              <span>Not Sorted</span>
            </div>
          </div>
        </div>
      </div>
      <div className="general-information-full">
        <div className="general-information-full-item">
          <div className="general-information-full-item-start">
            <p>Full name (EN)</p>
          </div>
          <VerticalLine />
          <div className={`general-information-full-item-middle ${editor ? "editor" : ""}`}>
            <p>{viewData?.userInfo.fullname}</p>
          </div>
          <VerticalLine />
          <div className={`general-information-full-item-end ${editor ? "editor" : ""}`}>
            {editor ? (
              <input
                placeholder="New meaning"
                value={draftData?.userInfo.fullname ?? ""}
                onChange={(e) => updateUserInfo("fullname", e.target.value)}
              />
            ) : (
              <p>{viewData?.applyInfo.updated}</p>
            )}
          </div>
        </div>
        <div className="general-information-full-item">
          <div className="general-information-full-item-start">
            <p>Full name (Nat.)</p>
          </div>
          <VerticalLine />
          <div className={`general-information-full-item-middle ${editor ? "editor" : ""}`}>
            <p>{viewData?.userInfo.fullname}</p>
          </div>
          <VerticalLine />
          <div className={`general-information-full-item-end ${editor ? "editor" : ""}`}>
            {editor ? (
              <input
                placeholder="New meaning"
                value={draftData?.userInfo.fullname ?? ""}
                onChange={(e) => updateUserInfo("fullname", e.target.value)}
              />
            ) : (
              <p>{viewData?.applyInfo.updated}</p>
            )}
          </div>
        </div>
        <div className="general-information-full-item">
          <div className="general-information-full-item-start">
            <p>Email</p>
          </div>
          <VerticalLine />
          <div className={`general-information-full-item-middle ${editor ? "editor" : ""}`}>
            <p>{viewData?.userInfo.email}</p>
          </div>
          <VerticalLine />
          <div className={`general-information-full-item-end ${editor ? "editor" : ""}`}>
            {editor ? (
              <input
                placeholder="New meaning"
                value={draftData?.userInfo.email ?? ""}
                onChange={(e) => updateUserInfo("email", e.target.value)}
              />
            ) : (
              <p>{viewData?.applyInfo.updated}</p>
            )}
          </div>
        </div>
        <div className="general-information-full-item">
          <div className="general-information-full-item-start">
            <p>Phone</p>
          </div>
          <VerticalLine />
          <div className={`general-information-full-item-middle ${editor ? "editor" : ""}`}>
            <p>{viewData?.userInfo.phone}</p>
          </div>
          <VerticalLine />
          <div className={`general-information-full-item-end ${editor ? "editor" : ""}`}>
            {editor ? (
              <input
                placeholder="New meaning"
                value={draftData?.userInfo.phone ?? ""}
                onChange={(e) => updateUserInfo("phone", e.target.value)}
              />
            ) : (
              <p>{viewData?.applyInfo.updated}</p>
            )}
          </div>
        </div>
        <div className="general-information-full-item">
          <div className="general-information-full-item-start">
            <p>Course</p>
          </div>
          <VerticalLine />
          <div className={`general-information-full-item-middle ${editor ? "editor" : ""}`}>
            <p>{viewData?.applyInfo.course}</p>
          </div>
          <VerticalLine />
          <div className={`general-information-full-item-end ${editor ? "editor" : ""}`}>
            {editor ? (
              <input
                placeholder="New meaning"
                value={draftData?.applyInfo.course ?? ""}
                onChange={(e) => updateApplyInfo("course", e.target.value)}
              />
            ) : (
              <p>{viewData?.applyInfo.updated}</p>
            )}
          </div>
        </div>
        <div className="general-information-full-item">
          <div className="general-information-full-item-start">
            <p>Language</p>
          </div>
          <VerticalLine />
          <div className="general-information-full-item-middle">
            <p> - </p>
          </div>
          <VerticalLine />
          <div className="general-information-full-item-end">
            <p>{viewData?.applyInfo.updated}</p>
          </div>
        </div>
        <div className="general-information-full-item">
          <div className="general-information-full-item-start">
            <p>Country</p>
          </div>
          <VerticalLine />
          <div className={`general-information-full-item-middle ${editor ? "editor" : ""}`}>
            <p>{viewData?.userInfo.country}</p>
          </div>
          <VerticalLine />
          <div className={`general-information-full-item-end ${editor ? "editor" : ""}`}>
            {editor ? (
              <input
                placeholder="New meaning"
                value={draftData?.userInfo.country ?? ""}
                onChange={(e) => updateUserInfo("country", e.target.value)}
              />
            ) : (
              <p>{viewData?.applyInfo.updated}</p>
            )}
          </div>
        </div>
        <div className="general-information-full-item">
          <div className="general-information-full-item-start">
            <p>Nationality</p>
          </div>
          <VerticalLine />
          <div className={`general-information-full-item-middle ${editor ? "editor" : ""}`}>
            <p>{viewData?.userInfo.nationality}</p>
          </div>
          <VerticalLine />
          <div className={`general-information-full-item-end ${editor ? "editor" : ""}`}>
            {editor ? (
              <input
                placeholder="New meaning"
                value={draftData?.userInfo.nationality ?? ""}
                onChange={(e) => updateUserInfo("nationality", e.target.value)}
              />
            ) : (
              <p>{viewData?.applyInfo.updated}</p>
            )}
          </div>
        </div>
        <div className="general-information-full-item">
          <div className="general-information-full-item-start">
            <p>Residence</p>
          </div>
          <VerticalLine />
          <div className="general-information-full-item-middle">
            <p> - </p>
          </div>
          <VerticalLine />
          <div className="general-information-full-item-end">
            <p>{viewData?.applyInfo.updated}</p>
          </div>
        </div>
        <div className="general-information-full-item">
          <div className="general-information-full-item-start">
            <p>Contact person</p>
          </div>
          <VerticalLine />
          <div className="general-information-full-item-middle">
            <p> - </p>
          </div>
          <VerticalLine />
          <div className="general-information-full-item-end">
            <p>{viewData?.applyInfo.updated}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GeneralInformation;
